import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface Props {
  crumbs: Crumb[];
}

export default function Breadcrumb({ crumbs }: Props) {
  return (
    <nav aria-label="面包屑" className="text-sm">
      <ol className="flex flex-wrap items-center gap-1.5 text-foreground-500">
        <li>
          <Link to="/" className="flex items-center gap-1 transition-colors hover:text-primary-700">
            <i className="ri-home-4-line" />
            首页
          </Link>
        </li>
        {crumbs.map((c, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line" />
            {c.to ? (
              <Link to={c.to} className="transition-colors hover:text-primary-700">
                {c.label}
              </Link>
            ) : (
              <span aria-current="page" className="font-medium text-foreground-800">
                {c.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}